import Vue from 'vue';
import VueRouter from 'vue-router';
import Layout from '@/layout';

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err);
};

Vue.use(VueRouter);

export const constantRoutes = [
	{
		path: '/redirect',
		component: Layout,
		name: 'redirect',
		hidden: true,
		children: [{
			path: '/redirect/:path(.*)',
			component: () => import('@/views/redirect/index')
		}]
	},
	{
		path: '/iframe/components/sendmsg',
		component: () => import('@/views/iframe/SendMsg/index'),
		hidden: true
	},
	{
		path: '/iframe/components/summary',
		component: () => import('@/views/iframe/Summary/index'),
		hidden: true
	},
	{
		path: '/iframe/components/cus/info',
		component: () => import('@/views/iframe/CusInfo/index'),
		hidden: true
	},
	{
		path: '/login',
		component: () => import('@/views/login/index'),
		hidden: true
	},
	{
		path: '/auth-redirect',
		component: () => import('@/views/login/auth-redirect'),
		hidden: true
	},
	{
		path: '/404',
		component: () => import('@/views/error/404'),
		hidden: true
	},
	{
		path: '/500',
		component: () => import('@/views/error/500'),
		hidden: true
	},
	{
		path: '/refresh',
		component: () => import('@/views/refresh/index'),
		hidden: true
	},
	{
		path: '/',
		component: Layout,
		redirect: '/welcome',
		children: [{
			path: '/welcome',
			component: () => import('@/views/dashboard/index'),
			name: 'Dashboard',
			meta: {
				title: 'dashboard',
				icon: 'home',
				affix: true
			}
		}]
	},
	{
		path: '/personalInfo',
		component: Layout,
		redirect: '/personalInfo/index',
		children: [{
				path: 'index',
				component: () => import('@/views/personalInfo'),
				name: 'PersonalInfo',
				meta: {
					title: "用户设置"
				},
				hidden: true
			},

		],
	},
	{
		path: '/wechatSuccess',
		component: () => import('@/views/system/wechat/success'),
		hidden: true
	},
	{
		path: '/messageCenter',
		component: Layout,
		children: [{
				path: 'index',
				component: () => import('@/views/messageCenter/index'),
				name: 'MessageCenter',
				meta: {
					title: "历史通知"
				},
				hidden: true
			},

		],
	},
	{
		path: '/versions',
		component: Layout,
		children: [{
			path: 'index',
			component: () => import('@/views/versions/index'),
			name: 'Versions',
			meta: {
				title: "版本信息"
			},
			hidden: true
		},
		{
			path: 'release',
			component: () => import('@/views/versions/Release'),
			name: 'Release',
			meta: {
				title: "版本发布"
			},
			hidden: true
		}]
	}
];

export const asyncRoutes = [
	// ! 系统配置 - 权限部分   后续应转移到system目录下
	{
		path: '/jurisdiction',
		component: Layout,
		redirect: '/jurisdiction/user',
		meta: {
			title: '权限管理',
			icon: 'quanxian',
		},
		children: [{
				path: 'user',
				component: () => import('@/views/jurisdiction/user/index'),
				name: 'user',
				meta: {
					title: '人员管理'
				}
			},
			{
				path: 'menu',
				component: () => import('@/views/jurisdiction/meau'),
				name: 'meau',
				meta: {
					title: '菜单管理'
				}
			},
			{
				path: 'brand',
				component: () => import('@/views/jurisdiction/brand/index'),
				name: 'brand',
				meta: {
					title: '配置中心'
				}
			},
			{
				path: 'brand/channel/:brand',
				component: () => import('@/views/jurisdiction/brand/components/channel'),
				name: 'brandChannel',
				meta: {
					title: '渠道管理'
				}
			},
			{
				path: 'role',
				component: () => import('@/views/jurisdiction/role/index'),
				name: 'role',
				meta: {
					title: '角色管理'
				}
			}
		]
	},
	// ! 电话渠道
	{
		path: '/tel',
		component: Layout,
		redirect: '/tel/index',
		meta: {
			title: 'telChannel',
			icon: 'tel',
		},
		children: [{
			path: 'index',
			component: () => import('@/views/tel/index'),
			name: 'serviceWindow',
			meta: {
				title: '服务窗口',
				keepAlive: true
			}
		}, {
			path: 'personal',
			component: () => import('@/views/tel/personal'),
			name: 'serviceWindowPersonal',
			meta: {
				title: '个人通话记录',
				keepAlive: true
			}
		}, {
			path: 'record',
			component: () => import('@/views/tel/record'),
			name: 'serviceWindowRecord',
			meta: {
				title: '通话记录',
				keepAlive: true
			}
		}, {
			path: 'message',
			component: () => import('@/views/tel/message'),
			name: 'serviceWindowMessage',
			meta: {
				title: '留言查询',
				keepAlive: true
			}
		}]
	},
	// ! IM渠道
	{
		path: '/im',
		component: Layout,
		redirect: '/im/index',
		meta: {
			title: 'IMChannel',
			icon: 'im',
		},
		children: [{
				path: 'index',
				component: () => import('@/views/im-channel/imService'),
				name: 'im',
				meta: {
					title: 'serviceWindow',
					keepAlive: true
				},
			},
			{
				path: 'queueManage',
				component: () => import('@/views/im-channel/queue'),
				name: 'queueManage',
				meta: {
					title: 'queueManage',
				},
			},
			// {
			//   path: 'holidayManage',
			//   component: () => import('@/views/im/holidayManage'),
			//   name: 'holidayManage',
			//   meta: { 
			//     title: 'holidayManage',
			//   },
			// },
			{
				path: 'imMonitor',
				component: () => import('@/views/im-channel/monitor'),
				name: 'imMonitor',
				meta: {
					title: 'imMonitor',
				},
			},
			{
				path: 'msgManage',
				component: () => import('@/views/im-channel/message'),
				name: 'msgManage',
				meta: {
					title: 'msgManage',
				},
			},
			// {
			//   path: 'holidayWords',
			//   component: () => import('@/views/im/holidayWords'),
			//   name: 'holidayWords',
			//   meta: { 
			//     title: 'holidayWords',
			//   },
			// }
		]
	},
	// ! 工单管理
	{
		path: '/workflow',
		component: Layout,
		redirect: '/workflow/index',
		meta: {
			title: '工单管理',
			icon: 'WorkFlow',
		},
		children: [{
			path: 'index',
			component: () => import('@/views/workflow/configure/index'),
			name: 'OCSWorkFlowConfigure',
			meta: {
				title: '工单配置',
				icon: 'Configure'
			}
		}]
	},
	// ! 短信管理
	{
		path: '/sms',
		component: Layout,
		redirect: '/sms/settings',
		meta: {
			title: '短信渠道',
			icon: 'WorkFlow',
		},
		children: [{
			path: 'settings',
			component: () => import('@/views/sms/settings/index'),
			name: 'OCSSmsSettings',
			meta: {
				title: '短信设置',
				icon: 'Configure'
			}
		}, {
			path: 'outbox',
			component: () => import('@/views/sms/outbox/index'),
			name: 'OCSSmsOutbox',
			meta: {
				title: '发件箱',
				icon: 'Configure'
			}
		}, {
			path: 'template',
			component: () => import('@/views/sms/template/index'),
			name: 'OCSSmsTemplate',
			meta: {
				title: '短信模板',
				icon: 'Configure'
			}
		}, {
			path: 'import/log',
			component: () => import('@/views/sms/importLog/index'),
			name: 'OCSSmsImportLog',
			meta: {
				title: '客户导入日志',
				icon: 'Configure'
			}
		}]
	},
	// ! 外呼任务
	{
		path: '/breathe',
		component: Layout,
		redirect: '/breathe/questionnaire',
		meta: {
			title: '外呼任务',
			icon: 'Breathe',
		},
		children: [{
			path: 'questionnaire',
			component: () => import('@/views/breathe/questionnaire/index'),
			name: 'Breathe',
			meta: {
				title: '问卷管理',
				icon: 'Questionnaire'
			}
		}, {
			path: 'questionnaire/design/:id',
			component: () => import('@/views/breathe/questionnaire/design'),
			name: 'BreatheDesign',
			meta: {
				title: '问卷管理-设计问卷',
				icon: 'Questionnaire'
			}
		}, {
			path: 'rule/api',
			component: () => import('@/views/breathe/api'),
			name: 'BreatheDesignRuleApi',
			meta: {
				title: 'API数据传输',
				icon: 'QuestionnaireAPI'
			}
		},{
			path: 'theme',
			component: () => import('@/views/breathe/theme/index'),
			name: 'Theme',
			meta: {
				title: '外呼主题'
			}
		},{
			path: 'task',
			component: () => import('@/views/breathe/task/index'),
			name: 'Task',
			meta: {
				title: '外呼任务'
			}
		},{
			path: 'task/status',
			component: () => import('@/views/breathe/task/taskStatus'),
			name: 'BreatheTaskStatus',
			meta: {
				title: '任务状态',
				icon: 'BreatheTaskStatus'
			}
		},{
			path: 'dataBase',
			component: () => import('@/views/breathe/dataBase/index'),
			name: 'DataBase',
			meta: {
				title: '外呼数据导入'
			}
		},{
			path: 'dataBase/info/:id',
			component: () => import('@/views/breathe/dataBase/info'),
			name: 'DataBaseInfo',
			meta: {
				title: '外呼数据导入详情'
			}
		},{
			path: 'reportForm',
			component: () => import('@/views/breathe/reportForm/index'),
			name: 'ReportForm',
			meta: {
				title: '外呼报表'
			}
		},{
			path: 'callOut',
			component: () => import('@/views/breathe/callOut/index'),
			name: 'CallOut',
			meta: {
				title: '执行外呼'
			}
		},{
			path: 'callOut/info/:id',
			component: () => import('@/views/breathe/callOut/info'),
			name: 'CallOutInfo',
			meta: {
				title: '执行外呼详情'
			}
		},{
			path: 'analyse',
			component: () => import('@/views/breathe/analyse/index'),
			name: 'analyse',
			meta: {
				title: '外呼任务分析表'
			}
		}, {
			path: 'dashboard',
			component: () => import('@/views/breathe/dashboard/index'),
			name: 'HWDashboard',
			meta: {
				title: '话务Dashboard'
			}
		}]
	},
	// ! 智能小助手
	{
		path: '/knowledge',
		component: Layout,
		redirect: '/knowledge/index',
		meta: {
			title: '智能小助手',
			icon: 'knowledge',
		},
		children: [{
			path: 'index',
			component: () => import('@/views/knowledge/index'),
			name: 'OCSKnowledgeIndex',
			meta: {
				title: '小助手',
				icon: 'knowledge'
			}
		}, {
			path: 'report',
			component: () => import('@/views/knowledge/report/index'),
			name: 'OCSKnowledgeReport',
			meta: {
				title: '报表',
				icon: 'knowledge'
			}
		}, {
			path: 'review',
			component: () => import('@/views/knowledge/review/index'),
			name: 'OCSKnowledgeReview',
			meta: {
				title: '审核',
				icon: 'knowledge'
			}
		}, {
			path: 'settings',
			component: () => import('@/views/knowledge/settings/index'),
			name: 'OCSKnowledgeSettings',
			meta: {
				title: '库权限管理',
				icon: 'knowledge'
			}
		}]
	},
	// ! 客户管理
	{
		path: '/customer',
		redirect: '/customer/index',
		component: Layout,
		children: [{
				path: 'index',
				component: () => import('@/views/customer/index'),
				name: 'customerPageIndex',
				meta: {
					title: 'customerManage',
					icon: 'customer'
				}
			},
			{
				path: 'info/:id',
				component: () => import('@/views/customer/infoPage'),
				name: 'customerInfo',
				meta: {
					title: '客户详情',
					icon: 'mai'
				}
			}
		]
	},
	// ! 沟通管理
	{
		path: '/communicate',
		redirect: '/communicate/index',
		component: Layout,
		children: [{
			path: 'index',
			component: () => import('@/views/communicate/index'),
			name: 'communicat',
			meta: {
				title: 'communicat',
				icon: 'mai'
			}
		}]
	},
	// ! 报表管理
	{
		path: '/report',
		component: Layout,
		children: [{
			path: 'report_view/:reportId',
			component: () => import('@/views/report/index'),
			name: 'report',
			meta: {
				title: '报表',
				icon: 'report'
			}
		},{
			path: 'config',
			component: () => import('@/views/report/ReportConfig/index'),
			name: 'report_config',
			meta: {
				title: '报表配置',
				icon: 'report'
			}
		},{
			path: 'download',
			component: () => import('@/views/report/ReportDownload/index'),
			name: 'report_download',
			meta: {
				title: '报表下载',
				icon: 'report'
			}
		}]
	},
	// ! 系统配置
	{
		path: '/system',
		component: Layout,
		children: [{
			path: 'index',
			component: () => import('@/views/system/index.vue'),
			name: 'system',
			meta: {
				title: 'system',
				icon: 'system'
			},
		}]
	},
	// ! iframe页面
	{
		path: '/iframe',
		component: Layout,
		// redirect: '/iframe/index',
		children: [{
			path: ':url',
			component: () => import('@/views/outlink/index.vue'),
			name: 'iframe',
			meta: {
				title: 'iframe',
				icon: 'iframe'
			}
		}]
	},
	// ! 通配
	{
		path: '*',
		redirect: '/404',
		hidden: true
	}
];

const createRouter = () => new VueRouter({
	// mode: 'history', // require service support
	scrollBehavior: () => ({
		y: 0
	}),
	routes: constantRoutes
});

const router = createRouter();
export function resetRouter() {
	const newRouter = createRouter();
	router.matcher = newRouter.matcher;
}

export default router;